import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import React from "react";
import Layout from "./pages/Layout";
import Home from "./pages/Home";
// import NoPage from "./components/NoPage";
// import AuthState from "./components/context/auth/AuthContext";
// import RequireAuth from "./components/RequireAuth";
import EditChallenge from "./pages/UpdateActivityStatus";
import { Form } from "./pages/Form";
import NoPage from "./pages/NoPage";
import RequireAuth from "./components/user/RequireAuth";
import LoginPage from "./pages/LoginPage";
import SignUpPage from "./pages/SignUpPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import Community from "./components/Form/Community";
import AdminHome from "./components/admin/AdminHome";
import JoinCommunity from "./pages/JoinCommunity";
import AllChallenges from "./pages/AllChallenges";
import LeaderBoard from "./pages/LeaderBoard";
import { useAuth } from "./components/context/auth/AuthState";
import Score from "./pages/Score";
import ProfilePage from "./pages/ProfilePage";

function AdminRoutes() {
  const { currentUser } = useAuth();

  return (
    <>
      <BrowserRouter>
        <div className="home-container">
          <Routes>
            {/* Auth Routes */}
            <Route path="login" element={<Outlet />}>
              <Route index element={<LoginPage />} />
              <Route path=":id" element={<LoginPage />} />
            </Route>
            <Route path="signup" element={<Outlet />}>
              <Route index element={<SignUpPage />} />
              <Route path=":id" element={<SignUpPage />} />
            </Route>
            <Route path="forgot-password" element={<ForgotPasswordPage />} />

            {/* Layout Routes */}
            <Route
              path="/"
              element={
                <Layout
                  footer={currentUser ? true : false}
                  viewMenu={currentUser ? true : false}
                />
              }
            >
              {/* Join Community Routes */}
              <Route path="join/:id" element={<JoinCommunity />} />
              {/* Routes Required User Authentication */}
              <Route path="" element={<RequireAuth />}>
                {/* User Routes */}
                <Route index element={<Home />} />
                <Route path="edit/:activityId" element={<EditChallenge />} />
                <Route path="join" element={<JoinCommunity />} />
                <Route path="all_challenges" element={<AllChallenges />} />
                <Route
                  path="report/:community_id"
                  element={<LeaderBoard />}
                />
                <Route
                  path="score/:community_id"
                  element={<Score />}
                />
                <Route path="profile" element={<ProfilePage />} />

                {/* Admin Routes */}
                <Route path="admin" element={<Outlet />}>
                  <Route index element={<AdminHome />} />
                  <Route path="create-community" element={<Community />} />
                  <Route path="form" element={<Form />} />
                  <Route path="form/:community_id" element={<Form />} />
                  <Route path="form/:community_name/:community_id" element={<Form />} />
                </Route>
              </Route>
              <Route path="*" element={<NoPage />} />
            </Route>
          </Routes>
        </div>
      </BrowserRouter>
    </>
  );
}

export default AdminRoutes;
